import React from 'react';
import NativeSelect, { SelectChangeEvent } from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { GridTableContext } from '../../contexts';
import { classes, PageSize } from './select-page-size.style';

export function SelectPageSize({ onChange }: { onChange?: () => void }): JSX.Element {
  const {
    paginationSize,
    instance: {
      state: { pageSize },
      setPageSize
    }
  } = React.useContext(GridTableContext);
  return (
    <PageSize>
      <Typography className={classes.label}>Rows</Typography>
      <NativeSelect
        native
        value={pageSize}
        onChange={(event: SelectChangeEvent<number>): void => {
          setPageSize(Number(event.target.value));
          if (onChange) {
            onChange();
          }
        }}
        variant='standard'
        className={classes.select}
      >
        {paginationSize.map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            {pageSize}
          </option>
        ))}
      </NativeSelect>
    </PageSize>
  );
}
